var __jsx = React.createElement;
import { cn } from "@lib/cn";
import { concatAllString } from "@lib/util/string-ops";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import React from "react";
export const PassengerDetailBase = _ref => {
  let {
    color,
    quantity,
    className
  } = _ref;
  const t = useTranslations('Flights');
  return __jsx("div", {
    className: "flex flex-row items-center gap-2"
  }, __jsx(Icons.personIconFilled, {
    color: color
  }), __jsx("p", {
    className: cn(color ? "text-".concat(color) : undefined, className)
  }, quantity && concatAllString(' ', quantity.toString(), t(quantity > 1 ? 'PASSENGERS' : 'PASSENGER'))));
};
export default PassengerDetailBase;